export const patientTherapeuticAreas = [
    { slug: 'onkologia', label: 'Onkologia' },
    { slug: 'reumatologia', label: 'Reumatologia' },
    { slug: 'neurologia', label: 'Neurologia' },
    { slug: 'psychiatria', label: 'Psychiatria' },
    { slug: 'urologia', label: 'Urologia' },
    { slug: 'osteoporoza', label: 'Osteoporoza' },
] as const;

export const patientMaterialSections = [
    { hash: 'dokumenty-do-pobrania', label: 'Pliki do pobrania' },
    { hash: 'artykuly', label: 'Artykuły' },
    { hash: 'materialy-video', label: 'Video' },
    { hash: 'podcasty', label: 'Podcasty' },
] as const;
